import AdminDistrictSisDashboardContainer from './AdminDistrictSisDashboardContainer';

export default AdminDistrictSisDashboardContainer;
